import pyplanLogoFull from 'assets/img/pyplan-logo-white.png'
import pyplanLogoDev from 'assets/img/pyplan-logo-dev.png'
import pyplanLogoColor from 'assets/img/pyplan-logo-color.png'
import pyplanLogoColorDev from 'assets/img/pyplan-logo-color-dev.png'
import pyplanLogoLoginDark from 'assets/img/pyplan-logo-login-dark.png'
import pyplanLogoLoginDarkDev from 'assets/img/pyplan-logo-login-dark-dev.png'

declare global {
  interface Window {
    _env_?: Record<string, string>
  }
}

export type UiBrandEnvironment = 'default' | 'dev'

const DEV_TOPBAR_LOGO_PATH = pyplanLogoDev

export const isTrueValue = (value?: string) => value?.trim().toLowerCase() === 'true'

/** Reads from runtime config first (window._env_), falls back to build-time env. */
export const getRuntimeEnv = (key: string): string | undefined =>
  window._env_?.[key] ?? process.env[key]

const getUiBrandEnvironment = (): UiBrandEnvironment => {
  const isDevelopEnvironment = isTrueValue(getRuntimeEnv('REACT_APP_DEVELOP_ENVIRONMENT'))
  if (isDevelopEnvironment) {
    return 'dev'
  }

  return 'default'
}

export const UI_BRAND_ENVIRONMENT = getUiBrandEnvironment()

export const getTopbarLogoByBrandEnvironment = () => {
  if (UI_BRAND_ENVIRONMENT === 'dev') {
    return DEV_TOPBAR_LOGO_PATH
  }

  return pyplanLogoFull
}

export const getLoginLogoByBrandEnvironment = (isDark: boolean) => {
  if (UI_BRAND_ENVIRONMENT === 'dev') {
    return isDark ? pyplanLogoLoginDarkDev : pyplanLogoColorDev
  }

  return isDark ? pyplanLogoLoginDark : pyplanLogoColor
}
